import { defineStore } from "pinia";

import modelClass from "@models/country";
import * as getters from "@modelStores/helpers/getters-helper";

export const useCountryStore = defineStore("country-store", {
  state: () => {
    return {
      resources: [] as Record<string, unknown>[],
    };
  },
  getters: {
    ...getters,
    modelClass: () => modelClass,
  },
});
